import { useContent } from '@/content'
import { Button } from '@/components/ui'

interface ResumeButtonProps {
  variant?: 'primary' | 'secondary' | 'solid'
  fullWidth?: boolean
  label?: string
}

/**
 * Downloads the CV, and nothing else.
 *
 * `download` plus a direct file URL, so the browser saves the PDF rather
 * than navigating to a viewer — the point of the button is to end up with
 * the file, not to look at it in a tab.
 *
 * Renders nothing when no CV has been uploaded. A download button that leads
 * to a 404 is worse than no button: it reads as neglect on the one page
 * whose job is to argue the opposite.
 */
export const ResumeButton = ({
  variant = 'primary',
  fullWidth = false,
  label = 'Download CV',
}: ResumeButtonProps) => {
  const { site } = useContent()

  return (
    <Button
      href={site.resume}
      variant={variant}
      fullWidth={fullWidth}
      leadingIcon="download"
      download
    >
      {label}
    </Button>
  )
}
